import { Languages } from "../../types";
import { createCustomerDictionary } from "./CreateCustomer";
import { customerProfileDictionary } from "./CustomerProfile";
import { customersDictionary } from "./Customers";
import { CustomerPagesDescriptions } from "./types";

export const getCustomerDescriptions = (systemLang: Languages): CustomerPagesDescriptions => ({
    CUSTOMERS: customersDictionary[systemLang],
    CREATE: createCustomerDictionary[systemLang],
    CUSTOMER_PROFILE: customerProfileDictionary[systemLang],
})